module.exports = __webpack_public_path__ + "8088b7e01c93e43ba7e2919543ec5f1d.gif";